export class RocketClass {
    
}
